export class RocketClass {
    
}
